import React from 'react';
import styled from 'styled-components/macro';

const NavList = ({
  childs,
  className = '',
  onSelection = () => { },
  selectedId,
}) => (
  <div className={className}>
    <Ul>
      {childs.map((child) => (
        <Li key={child.i} selected={selectedId === child.i}>
          <NavButton onClick={() => { onSelection(child.i) }}>
            {child.n}
          </NavButton>
        </Li>
      ))}
    </Ul>
  </div>
);

const StyledList = styled(NavList)`
  padding: 0px;
  overflow:auto
`;

const Ul = styled.ul`
  overflow: auto;
  font-size: 1.4rem;
`;


const Li = styled.li`
  color: #333 ;
  font-weight: 400;
  font-weight: ${({ selected }) => selected && 'bold'};
  color: ${({ selected }) => selected && '#164192'};

  &:nth-child(odd) {
    background: white;
  }
  &:nth-child(even) {
    background: #F5F8FD;
  }
`;

const NavButton = styled.button`
  padding:1rem;
  box-sizing: border-box;
  width: 100%;
  display:flex;
  color:#164192;
  color: ${({ selected }) => selected && '#164192'};
  background: inherit;
  &:hover,
  &:focus,
  &:active {
    font-weight:bold;
    color:#164192;
  }
`
export default StyledList;
